`
<!--
* @Description:疾病覆盖
* @Date: 2024-01-27 16:46:01
-->
<template>
  <div
    ref="TaskRef"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0 0'
    }"
  >
    <div class="disease-coverage" ref="ContentRef">
      <div class="content">
        <div class="content-warp">
          <div class="content-warp-circle1"></div>
          <div class="content-warp-circle1-border">
            <div style="width: 819.22px; height: 819.22px">
              <svgCircleDasharray opacitys="0.3"></svgCircleDasharray>
            </div>
          </div>
          <div class="content-warp-circle2">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
              <svgCircleDasharray opacitys="0.5"></svgCircleDasharray>
            </svg>
          </div>
          <div class="content-warp-circle3"></div>
          <div class="content-warp-circle3-border"></div>
          <div class="content-warp-circle4">
            <div>
              <div><svgDiseaseCoverage1></svgDiseaseCoverage1></div>
            </div>
          </div>
          <div class="content-warp-text">
            <div
              class="content-warp-text-r"
              v-for="(item, index) in data"
              :key="index"
              :style="`transform: translateY(50%) rotate(${
                (180 / data.length) * index + 180 / data.length / 2
              }deg)`"
            >
              <div class="text-tips">
                <div class="inner">
                  <div class="inner-r">
                    <div class="triangle"></div>
                    <div>
                      <div>{{ item }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="content-warp-text-rs"
              v-for="(item, index) in data"
              :key="index"
              :style="`transform: translateY(50%) rotate(${
                (180 / data.length) * index
              }deg)`"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  svgDiseaseCoverage1,
  svgCircleDasharray
} from './svg-components/index';
import { ref, onMounted } from 'vue';
import { selfAdaption } from './hooks';
const props = defineProps<{ optionData: string }>();
let data = ref(props.optionData.split(';'));
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});
</script>

<style lang="scss" scoped>
@import './index.scss';
.disease-coverage {
  --opacitys: 0.5;
  width: 1024px;
  height: 540px;
  display: grid;
  .content {
    width: 821.22px;
    height: 410.61px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    display: grid;
    overflow: hidden;
    border-bottom: 2px solid var(--theme-color-1, #000);

    .content-warp {
      margin: auto;
      margin-top: 1px;
      width: 821.22px;
      height: 821.22px;
      border-bottom: 2px solid var(--theme-color-1, #000);
      position: relative;

      .content-warp-circle1 {
        @include alignCenter();
        width: calc(819.22px - 3px);
        height: calc(819.22px - 3px);
        // width: 816.22px;
        // height: 816.22px;
        border-radius: 100%;
        display: grid;
        background: linear-gradient(
          360deg,
          #ffffff 60%,
          var(--theme-color-1, #000) 100%
        );
        opacity: 0.3;
        > div {
          margin: auto;
        }
      }
      .content-warp-circle1-border {
        @include alignCenter();
        width: 821.22px;
        height: 821.22px;
        border-radius: 100%;
      }
      .content-warp-circle2 {
        @include alignCenter();
        width: 533px;
        height: 533px;
        border-radius: 100%;
      }
      .content-warp-circle3 {
        @include alignCenter();
        width: 394.4px;
        height: 394.4px;
        border-radius: 100%;
        border: 2px solid var(--theme-color-1, #000);
        background-color: var(--theme-color-1, #000);
        opacity: var(--opacitys);
      }
      .content-warp-circle3-border {
        @include alignCenter();
        width: 394.4px;
        height: 394.4px;
        border-radius: 100%;
        border: 2px solid var(--theme-color-1, #000);
      }
      .content-warp-circle4 {
        z-index: 1;
        @include alignCenter();
        width: 250.69px;
        height: 250.69px;
        border-radius: 100%;
        border: 2px solid var(--theme-color-1, #000);
        background-color: #ffffff;
        > div {
          width: 200px;
          height: 125.34px;
          margin: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          > div {
            width: 66.34px;
            height: 70.24px;
            text-align: center;
          }
        }
      }
      .content-warp-text {
        width: 821.22px;
        height: 410.61px;
        position: absolute;
        .content-warp-text-r {
          bottom: 0;
          right: 50%;
          position: absolute;
          width: 300px;
          height: 2px;
          transform-origin: right;
          transform: translateY(50%) rotate(0deg);
          .text-tips {
            position: relative;
            width: 100%;
            height: 100%;
            .inner {
              top: -25px;
              right: 250px;
              position: absolute;
              width: 154.29px;
              height: 50.26px;
              transform: rotate(90deg);
              .inner-r {
                width: 154.29px;
                height: 50.26px;
                transform: rotate(180deg);
                position: relative;
                .triangle {
                  top: 36px;
                  left: 43%;
                  position: absolute;
                  width: 20px;
                  height: 20px;
                  border-bottom-right-radius: 2px;
                  background-color: var(--theme-color-1, #000);
                  transform: rotate(45deg);
                }
                > div:nth-child(2) {
                  position: absolute;
                  z-index: 2;
                  width: 154.29px;
                  height: 50.26px;
                  background-color: var(--theme-color-1, #000);
                  border-radius: 7px;
                  color: #ffffff;
                  display: flex;
                  padding: 5px;
                  justify-content: center;
                  align-items: center;
                  > div {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 400;
                  }
                }
              }
            }
          }
        }
        .content-warp-text-rs {
          bottom: 0;
          right: 50%;
          position: absolute;
          width: 410px;
          // height: 154.29px;
          height: 2px;
          background-color: var(--theme-color-1, #000);
          transform-origin: right;
          transform: translateY(50%) rotate(0deg);
          .text-tips {
            position: relative;
            width: 100%;
            height: 100%;
            .inner {
              top: -15px;
              right: 250px;
              position: absolute;
              width: 154.29px;
              height: 50.26px;
            }
          }
        }
      }
    }
  }
}
</style>
`
